import Teacher from "./teacher";

function Entity(data = {}) {
    /* ========= IDs ========= */
    this.externalId = data.externalId ?? data.id ?? null;
    this.id = data.id ?? data.externalId ?? null;
    this.courseExternalId = data.courseExternalId ?? null;

    /* ========= META ========= */
    this.type = data.type;
    this.providerName = data.providerName;
    this.providerDescription = data.providerDescription;
    this.providerLogo = data.providerLogo;
    this.system = data.system;
    this.nmmId = data.nmmId;

    /* ========= BASIC ========= */
    this.name = data.name;
    this.alias = data.alias; // delete
    this.description = data.description;
    this.link = data.link;
    this.picture = data.picture;
    this.mobilePicture = data.mobilePicture; // delete
    this.desktopPicture = data.desktopPicture; // delete

    /* ========= CLASSIFICATION ========= */
    this.domain = data.domain ?? data.standarts?.Domain;
    this.domains = data.domains;
    this.domainColor = data.domainColor;
    this.sharedDomain = data.sharedDomain;
    this.category = data.category;
    this.tags = data.tags;
    this.sections = data.sections;
    this.endpoints = data.endpoints;
    this.languages = data.languages;
    this.searchIncludeKeys = data.searchIncludeKeys; // delete

    /* ========= TEACHERS ========= */
    this.teachers = Array.isArray(data.teachers)
        ? data.teachers.map(t => (t instanceof Teacher ? t : new Teacher(t)))
        : undefined;

    /* ========= COURSE ========= */
    this.courseName = data.courseName; // delete
    this.folderId = data.folderId; // delete
    this.enrollmentData = data.enrollmentData; // delete
    this.programName = data.programName; // delete
    this.loginToCourseText = data.loginToCourseText; // delete
    this.assessments = data.assessments;
    this.calendarEvents = data.calendarEvents;
    this.oldCourse = data.oldCourse;

    /* ========= CLASS RANGE ========= */
    this.fromClass = data.fromClass;
    this.toClass = data.toClass;
    this.classId =
        data.fromClass != null && data.toClass != null
            ? Array.from(
                  { length: data.toClass - data.fromClass + 1 },
                  (_, i) => String(data.fromClass + i)
              )
            : null; // delete

    this.unitRange =
        data.minUnit != null && data.maxUnit != null
            ? Array.from(
                  { length: data.maxUnit - data.minUnit + 1 },
                  (_, i) => data.minUnit + i
              )
            : null; // delete

    /* ========= EVENTS ========= */
    this.title = data.title ?? data.name;
    this.date = data.date;
    this.from = data.from ?? data.fromDate;
    this.to = data.to ?? data.toDate;
    this.allDayEvent = data.allDayEvent;
    this.location = data.location;
    this.repeat = data.repeat; // delete

    /* ========= ASSESSMENT ========= */
    this.dueDate = data.dueDate;
    this.isAssessment = data.isAssessment;
    this.isSubmitted = data.isSubmitted;
    this.isCurrent = data.isCurrent; // delete

    /* ========= FLAGS ========= */
    this.hiddenPopup = data.hiddenPopup;
    this.hiddenLink = data.hiddenLink;
    this.componentPromotion = data.componentPromotion; // delete

    /* ========= STANDARDS ========= */
    this.standarts = data.standarts; // delete
    this.holiday = data.standarts?.IsHoliday;

    /* ========= OTHER ========= */
    this.addtionalData = data.addtionalData;
    this.copyFields = data.copyFields; // delete
    this.createdDate = data.createdDate; // delete
    this.state = data.state; // delete
    this.owner = data.owner; // delete
    this.ownerId = data.ownerId;
    this.bagrut = data.bagrut;
    this.bgt = data.bgt; // delete
    this.schoolId = data.schoolId;
    this.studyGroupId = data.studyGroupId;
    this.toolLevel = data.toolLevel;
    this.sourceTypeId = data.sourceTypeId;
    this.targetGroupId = data.targetGroupId;
    this.gradeMask = data.gradeMask;
    this.count = data.count;
}

export default Entity;
